var angular = require('angular');
var _module = require('../../module');

require('../../../services/analytics');


_module.component('searchBoxVideo', {
    controllerAs: 'sbv',
    controller: [
        '$log',
        '$window',
        '$state',
        '$stateParams',
        '$analytics',

        function searchBoxVideoCtrl($log, $window, $state, $stateParams, $analytics) {
            var _this = this;

            var trackSearchSubmit = function (params) {
                $analytics.eventTrack('Listing Search Submit', {
                    Source: 'Nest Search Box Widget',
                    'Search Term': params.q,
                    'Affiliate Code': params.affiliate
                });
            };

            var initSearchKeyword = function () {
                _this.keyword = '';
            };

            var getContainerElement = function () {
                var containerEl = angular.element( document.querySelector('.search-box-video') );
                return containerEl;
            };

            var loadTheme = function () {
                var containerEl = getContainerElement();
                if($stateParams.theme && $stateParams.theme.length && containerEl) {
                    containerEl.addClass($stateParams.theme);
                }
            };

            var initLayout = function () {
                // make body transparent
                angular.element( document.querySelector('html') ).addClass('transparent');
                angular.element( document.querySelector('body') ).addClass('transparent');

                var hideVideo = String($stateParams.hideVideo) === 'true' || false;
                var responsive = String($stateParams.responsive) === 'true' || false;
                _this.layout = {
                    hideVideo: hideVideo,
                    responsive: responsive
                };

                if(hideVideo) {
                    var containerEl = getContainerElement();
                    if(containerEl) {
                        containerEl.addClass('hide-video');
                    }
                }
            };

            var init = function () {
                initLayout();
                initSearchKeyword();
                loadTheme();
            };

            init();

            this.onSubmit = function () {
                if(_this.keyword && _this.keyword.length && $stateParams.affiliate) {
                    var params = {
                        q: _this.keyword,
                        affiliate: $stateParams.affiliate
                    };
                    trackSearchSubmit(params);
                    var url = $state.href('search', params);
                    window.open(url);
                }
            };
        }
    ],
    template: require('./index.html')
});
